module.exports = __webpack_public_path__ + "img/streamer-img.cda2b612.png";